module.exports = __webpack_public_path__ + "img/11-min.7b75ecf4.jpg";